import {useMemo} from "react";
import {useTranslation} from "react-i18next";

export default function useIntegrationScript(scriptName, integrationId) {
    let {t} = useTranslation();

    return useMemo(
        () => {
            if (integrationId === null) {
                return t('integration.shoptet.create-integration-to-show-script');
            }

            // noinspection JSUnresolvedLibraryURL
            return `<meta name="datixo-integration-id" content="${integrationId}">`
                + "\n" + `<script src="https://api.datixo.app/static/integrations/${scriptName}.js"></script>`;
        },
        [scriptName, integrationId]
    );
}
